import { Divider, Grid, Stack } from '@mui/material'
import { Box } from '@mui/system'
import MUIDataTable from 'mui-datatables'
import React, { useState } from 'react'
import { ContainedButton } from '../../components/600/MyButtons'
import { useEffect } from 'react'
import { MyDropdown } from '../../components/600/MyDropdown'
//import api from '../api/mainAPI' //axios req cors and proxy enabled ig
//import BatchReportContext from './contexts/ContextProvider'
import StaffReportContext  from '../../context/600/StaffReportContextProvider'
import CourseReportContext from '../../context/600/CourseReportContextProvider'
import { useContext } from 'react'
import { MyTab } from '../../components/600/MyTabs'
import { MyBarChartCard, MyPieChartCard, MyTextCard } from '../../components/600/MyCards'
// import { LoadCoverage } from './loadCoverage'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'


const options = {
  filterType: 'checkbox',
};

const CourseReport = () => {
  
  // const [reportState, reportDispatch] = useContext(BatchReportContext)
  const [reportState, reportDispatch] = useContext(CourseReportContext)
  const [visualize, setVisualize] = useState(false);
  const api = useAxiosPrivate()

  useEffect(() => {
    api.get('/reports/courses')
    .then(res => {
      // console.log(res.data)
      reportDispatch({type: 'loadCourse', payload: {
        totalCourse: res.data.totalCount,
        activeCourse : res.data.activeCourseCount, 
        groups: res.data.groupCount, 
        semesters: res.data.semesters, 
        selectedSemester: res.data.currentTerm.semester_term,
        selectedTerm: res.data.currentTerm.academic_year, 
        tableData: res.data.tableData,
        tableHeader: res.data.tableHeader,
        extension : res.data.extension,
        regular : res.data.regular,
        undergraduate : res.data.undergard,
        postgraduate : res.data.postgrad
      }}) 
  })}, [])

  // useEffect(() => {
  //   api.get("batchReport/filter",{
  //     params:{
  //       semester: reportState.selectedSemester,
  //       term: reportState.selectedTerm,
  //       department: 1,
  //       tab: reportState.tab,
  //     }
  //   })
  //   .then(res => console.log(res.data))
  //   .catch(err => console.log('Error:', err))
  // }, [reportState.selectedTerm, reportState.selectedSemester, reportState.tab])
  var terms = reportState.semesters.filter(semester => semester.semester_term === 1).map(filteredSemester => (filteredSemester.academic_year))

  const handleSemesterFilter = (e) => {
    reportDispatch({ type: 'changeSemester', payload: {selectedSemester: e.target.value}})
  }
  const handleTermFilter = (e) => {
    reportDispatch({ type: 'changeTerm', payload: {selectedTerm: e.target.value}})
  }
  function handleTabChange(value) {
    reportDispatch({ type: 'changeTab', payload: {selectedTab: value}})
  }
  function handleVisualization() {
    setVisualize(!visualize)
  }

  return (
    <Box 
    sx={{m: 2}}
    >
      {/* Filters */}
      <Stack 
          direction={{xs: 'column', sm: 'row'}}
          alignItems={{xs:'right', sm: 'center'}}
          justifyContent='flex-end'
          spacing={2}
          divider={<Divider orientation='vertical' flexItem/>}
          sx={{
            m: 1, 
            md: {
              backgroundColor: '#ff0',
            }
          }}
      >
          {/* Semester filter */}
          <MyDropdown inputs={{
            name: 'Semester', 
            defaultValue: reportState.selectedSemester,
            handleChange: handleSemesterFilter,
            id: 'Semester_filter', 
            values: [1, 2],
          }} />

          {/* Term Filter */}
          <MyDropdown inputs={{
            name: 'Term', 
            defaultValue: `${reportState.selectedTerm}`,
            handleChange: handleTermFilter,
            id: 'Term_filter', 
            values: terms,
          }} />

          {/* Charts Toggle Button */}
          <ContainedButton 
            variant='contained' 
            color='secondary'
            onClick={handleVisualization}  
          >
            {visualize ? "Visualize" : "Report"}
          </ContainedButton>
      </Stack>
      {/* Visualize */}
      <Grid container 
          spacing={{ xs: 2, md: 3 }} 
          columns={{ xs: 4, sm: 8, md: 12 }} 
          sx={{m: 1, mb: 2}}
      >
          <MyTextCard inputs={{
            value: reportState.totalCourse,
            title: 'Courses Owned',
            size: 3,
          }}/>
          <MyTextCard inputs={{
            value: reportState.activeCourse,
            title: 'Active courses',
            size: 3,
          }}/>
          {visualize && 
          <MyBarChartCard inputs={{
            title: "Program",
            option1: 'Regular',
            value1: reportState.regular,
            option2: 'Extension',
            value2: reportState.extension
          }}/>}
          {visualize && 
          <MyBarChartCard inputs={{
              title: 'Admission',
              option1: 'Undergraduate',
              value1: 1,
              option2: 'Postgraduate',
              value2:4
            }} 
          />}
          {!visualize && 
          <MyPieChartCard inputs={{
              mydata: {
                name: "Program",
                option1: "Regular",
                option2: "Extension",
                value1: reportState.regular,
                value2: reportState.extension,
              },
            }}
          />}
          {!visualize && 
          <MyPieChartCard inputs={{
            mydata: {
              name: "Admission",
              option1: "Undergraduate",
              option2: "Postgraduate",
              value1: 4,
              value2:1,
            },
          }}/>
          }
      </Grid>
      {/* Load Coverage */}
      {/* <LoadCoverage  inputs={{
        load: reportState.load
      }}/> */}
      {/* Tabs */}

    <MUIDataTable 
        title={reportState.tableHeader}
        data={reportState.tableData} 
        columns={reportState.tableColumn}
        options={options}
    />
    </Box>
  )
}

export default CourseReport